import { http } from "@/communication";

const roleModule = {
  namespaced: true,
  state: {
    roles: []
  },
  actions: {
    read({ dispatch, getters }) {
      if (!getters["all"].length) {
        return dispatch("forceLoad");
      }
    },
    forceLoad({ commit }) {
      return http
        .get("/api/v1/role")
        .then(({ data }) => {
          commit("update", data);
        })
        .catch(error => {
          console.log("Roles error", error);
        });
    }
  },
  mutations: {
    update(state, roles) {
      state.roles = roles;
    }
  },
  getters: {
    all: state => state.roles
  }
};

export default roleModule;
